export const chartStyles = `
  .chart-point {
    cursor: pointer;
    transition: r 0.2s ease;
  }
  .chart-point:hover {
    r: 2;
  }
`;

export const chartContainerStyles = (theme) => ({
  width: '100%',
  height: '100%',
  minHeight: 180,
  padding: theme.spacing(1),
  backgroundColor: '#f8fafc',
  borderRadius: theme.shape.borderRadius,
  '& .MuiChartsAxis-line': {
    stroke: '#94a3b8',
  },
  '& .MuiChartsAxis-tick': {
    stroke: '#94a3b8',
  },
  '& .MuiChartsAxis-label': {
    fill: '#64748b',
    fontSize: '0.75rem',
  },
});

export const chartConfig = {
  height: 250,
  margin: { top: 20, right: 20, bottom: 30, left: 70 },
  sx: {
    '.MuiLineElement-root': {
      strokeWidth: 2,
    },
    '.MuiAreaElement-root': {
      fillOpacity: 0.1,
    }
  }
};